import '@shui/core/sh-table';

import { Component, booleanAttribute, input, numberAttribute, ChangeDetectionStrategy } from '@angular/core';
import { ShTableColumns } from '../sh-table-types';

@Component({
    selector: 'sh-table-cell',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.checkbox]': 'checkbox() ? "" : null',
        '[attr.columns]': 'columns() ?? null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.icon]': 'icon() ? "" : null',
        '[attr.min-width]': 'minWidth() ?? null',
        '[attr.number]': 'number() ? "" : null'
    }
})
export class ShTableCellComponent {
    /**
     * Gives the cell a fixed width for first-column multi-selection checkboxes.
     * Place an `<sh-checkbox>` inside when using this.
     */
    public readonly checkbox = input(false, { transform: booleanAttribute });

    /** Column width as a fraction of the 24-column grid. */
    public readonly columns = input<ShTableColumns | undefined, string | number | undefined>(undefined, {
        transform: v => (v == null ? undefined : (numberAttribute(v) as ShTableColumns))
    });

    /** Applies condensed spacing to the cell. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** Gives the cell a fixed width of 2 rem. Use for icon-only columns. */
    public readonly icon = input(false, { transform: booleanAttribute });

    /**
     * Minimum width before horizontal scrolling kicks in.
     * Default SHUI value is `'2.5rem'`.
     */
    public readonly minWidth = input<string | undefined>(undefined);

    /** Right-aligns text in the cell. */

    public readonly number = input(false, { transform: booleanAttribute });
}
